import React from "react";
// import { Link } from "react-router-dom";

const CustomCarousel = () => {
return (
<section className="row">
<div className="col-md-12">
{/* Carousel starts here */}
<div id="mycarousel" className="carousel slide" data-bs-ride="carousel">
{/* Wrapping images or items */}
<div className="carousel-inner">
<div className="carousel-item active">
<img src="images/jalistep/slide1.jpg" alt="Slide 1" className="w-100 d-block" />
</div>
<div className="carousel-item">
<img src="images/jalistep/slide2.jpg" alt="Slide 2" className="w-100 d-block"/>
</div>

</div>

{/* Controllers */}
<a className="carousel-control-prev" href="#mycarousel" role="button" data-bs-slide="prev">
<span className="carousel-control-prev-icon " aria-hidden="true"></span>
</a>

<a className="carousel-control-next" href="#mycarousel" role="button" data-bs-slide="next">
<span className="carousel-control-next-icon " aria-hidden="true"></span>
</a>
</div>
</div>
</section>
);
};

export default CustomCarousel;